var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Profile_-_Selected",
    width: 24,
    height: 24,
    "data-name": "Icon - Profile - Selected",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:0}\n            .prefix__cls-3{fill:none;stroke-linecap:round;stroke-width:2px;stroke:#EE5294;stroke-miterlimit:10}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0h24v24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Profile_-_Selected-2",
    "data-name": "Icon - Profile - Selected",
    transform: "translate(5 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0h14v16H0z",
    className: "prefix__cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3614",
    "data-name": "Group 3614",
    transform: "translate(.778 .8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_129",
    fill: "none",
    stroke: "##0A0D14",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M0 0L12 0",
    "data-name": "Line 129",
    transform: "translate(0 14.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6229",
    d: "M2 17.344a6.313 6.313 0 0 1 6.222-6.4 6.313 6.313 0 0 1 6.222 6.4",
    className: "prefix__cls-3",
    "data-name": "Path 6229",
    transform: "translate(-2 -2.944)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_764",
    cx: 3.889,
    cy: 4,
    className: "prefix__cls-3",
    "data-name": "Ellipse 764",
    rx: 3.889,
    ry: 4,
    transform: "translate(2.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileSelected);
export default __webpack_public_path__ + "static/media/icon-profile-selected.1e82dfbb2437345ebe8943bcc826904c.svg";
export { ForwardRef as ReactComponent };